import styled, { css } from 'styled-components'

export const CompanyItemWrapper = styled.div`
    background-color: #fff;
    border-radius: 6px;
    border: 1px solid #efefef;
    padding: 16px;
    margin-bottom: 8px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    @media (max-width: 768px) {
        display: block;
    }
`

export const LogoSection = styled.a`
    width: 70px;
    height: 70px;
    border-radius: 10px;
    filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.1));
    background-color: #fff;
    margin-right: 16px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    padding: 10px;
    position: relative;
    img {
        width: 100%;
        padding: 10px !important;
        object-fit: contain;
    }
`

export const ContentSection = styled.div<{ isShowFollow: boolean }>`
    width: ${({ isShowFollow }) => (isShowFollow ? 'calc(100% - 186px)' : 'calc(100% - 86px)')};
    margin-right: 16px;
    @media (max-width: 768px) {
        margin-right: 0;
        width: calc(100% - 86px);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
    }
`

export const GroupContent = styled.div`
    display: flex;
    width: calc(100% - 100px);
    margin-right: 16px;
    @media (max-width: 768px) {
        width: 100%;
    }
`

export const CompanyDescription = styled.p<{ isFolderIcon?: boolean }>`
    color: #777;
    font-size: 13px;
    line-height: 20px;
    margin: 0 0 6px 0;
    width: fit-content;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    display: flex;
    span {
        width: fit-content;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
    }
    ${({ isFolderIcon }) => {
        if (!isFolderIcon) {
            return ''
        }
        return css`
            > span > svg {
                margin-right: 4px;
            }
        `
    }}
`

export const ActionSection = styled.div`
    width: 100px;
    display: flex;
    justify-content: flex-end;
    @media (max-width: 768px) {
        display: block;
        width: 100%;
        margin-top: 8px;
        > button {
            width: 100%;
        }
    }
`

export const LocationName = styled.div`
    margin-left: 8px;
`

export const CompanyJobCount = styled.div`
    color: #777;
    font-size: 13px;
    line-height: 20px;
    margin-left: 16px;
    > svg {
        margin-right: 4px;
    }
`
